import {
    /** FETCH DELETEBASKET  */
    FETCH_DELETEBASKET_FULFILLED,
    FETCH_DELETEBASKET_REJECTED,
    FETCH_DELETEBASKET_PENDING,
    RESET_DELETEBASKET,
  } from "../../actions/payment/deleteBasket";
  const initialState = {
    done: false,
    error: false,
    spinner: false,
  };
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case FETCH_DELETEBASKET_PENDING:
        return {
          done: false,
          error: false,
          spinner: true,
        };
      case FETCH_DELETEBASKET_FULFILLED:
        return {
          ...state,
          deleteBasket: action.payload,
          done: true,
          error: false,
          spinner: false,
        };
      case FETCH_DELETEBASKET_REJECTED:
        return {
          ...state,
          error: action.payload,
          done: false,
          spinner: false,
        };
      case RESET_DELETEBASKET:
        return {
          initialState,
          done: false,
          error: false,
          spinner: false,
        };
      default:
        return state;
    }
  };
  